<template>
    <div>
        <el-row class="warp">
            <el-col :span="24" class="warp-breadcrum">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/' }"><b>首页</b></el-breadcrumb-item>
                    <el-breadcrumb-item>监控追溯</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
            <el-col>
                
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
                <!--工具条-->
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true" :model="searchForm">
                    <el-form-item label='时间类别：'>
                        <el-select  v-model="searchForm.type" placeholder="事件类别">
                            <el-option v-for='(item,index) in typeSelect' :key="index" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label='设备短号：'>
                        <el-input v-model="searchForm.deviceCode" placeholder="请输入设备短号"></el-input>
                    </el-form-item>
                    <el-form-item label='发生时间：'>
                        <el-date-picker
                            v-model="searchForm.date"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="发生时间"
                            end-placeholder="发生时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" v-on:click="handleSearch">查询</el-button>
                    </el-form-item>
                    </el-form>
                </el-col>

                <!--列表-->
                <el-table :data="devices" highlight-current-row v-loading="loading" border style="width: 100%;">
                    <el-table-column type="index" label="序号" width="50" fixed="left" align="center"></el-table-column>
                    <el-table-column prop="createDate" label="发生时间" fixed="left" width="180" align="center"></el-table-column>
                    <el-table-column prop="warType" label="事件类别" width="150"  align="center">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.warType ==='1'" style="color:red">失联</el-tag>
                            <el-tag v-if="scope.row.warType ==='2'" style="color:#c15757">低电压提示</el-tag>
                            <el-tag v-if="scope.row.warType ==='3'" style="color:#f7acac">严重低电</el-tag>
                            <el-tag v-if="scope.row.warType ==='4'" style="color:#ecdb04">水位过低</el-tag>
                            <el-tag v-if="scope.row.warType ==='5'" style="color:#716905">水位过高</el-tag>
                            <el-tag v-if="scope.row.warType ==='6'" style="color:#07a9f7">水压过低</el-tag>
                            <el-tag v-if="scope.row.warType ==='7'" style="color:#04364e">水压过高</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="warState" label="告警状态" width="150"  align="center">
                         <template slot-scope="scope">
                            <el-tag v-if="scope.row.warState ==='0'" style="color:red">未解除</el-tag>
                            <el-tag v-if="scope.row.warState ==='1'" style="color:green">已解除</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="sure" label="确认情况" width="150"  align="center">
                         <template slot-scope="scope">
                            <el-tag v-if="scope.row.sure ==='0'" style="color:red">未确认</el-tag>
                            <el-tag v-if="scope.row.sure ==='1'" style="color:green">已确认</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="note" label="通知情况" width="150"  align="center">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.note ==='0'" style="color:red">未通知</el-tag>
                            <el-tag v-if="scope.row.note ==='1'" style="color:green">通知已送达</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deviceCode" label="设备短号" width="200"  align="center"></el-table-column>
                    <el-table-column prop="netCode" label="网关号" width="180"  align="center"></el-table-column>
                    <el-table-column prop="address" label="地址" width="380"  align="center"></el-table-column>
                    <el-table-column prop="position" label="位置" width="220"  align="center"></el-table-column>
                    <el-table-column prop="deviceNo" label="型号" width="150"  align="center"></el-table-column>
                </el-table>

                <!--分页工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[20, 40, 60, 100]"
                    :page-size="20" background layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right;">
                    </el-pagination>
                </el-col>

            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    data(){
      return{
        devices:[],
        loading:false,
        total: 0,
        page: 1,
        limit: 20,
        //查询条件
        searchForm:{
          type:"",
          date:"",
          deviceCode:""
        },
        typeSelect:[{
            value:'1',label:'失联'},
            {value:'2', label:'低电压提示'},
            {value:'3',label:'严重低电'},
            {value:'4',label:'水位过低'},
            {value:'5',label:'水位过高'},
            {value:'6',label:'水压过低'},
            {value:'7',label:'水压过高'},
        ]
      }
    },
    methods: {
      usedFormatter:function(row, column){
          if(row.usedState==="1"){
              return "在使用"
          }else{
              return "未使用";
          }
          
      },
      //分页切换每页条数
      handleSizeChange:function(val){
        this.limit = val;
        this.search();
      },
      //分页切换页码
      handleCurrentChange:function(val){
        this.page = val;
        this.search();
      },
      //查询按钮
      handleSearch:function(){
        this.page=1;
        this.total=0;
        this.search();
      },
      //查询方法
      search:function(){
          let that = this;
          that.total=59;
          that.page=1;
          this.devices=[
{deviceCode:'863703039155507',warType:'1',netCode:'-21100103',deviceNo:'DZ02Q',warState:'1',sure:'1',note:'1',address:'河南省郑州市长宁路1033号',position:'',createDate:'2018.06.27'},
{deviceCode:'863703036218985',warType:'2',netCode:'-876543',deviceNo:'DZ02QS',warState:'1',sure:'1',note:'0',address:'河南省郑州市1033号',position:'',createDate:'2018.05.14'},
{deviceCode:'863703035183909',warType:'3',netCode:'-591100103',deviceNo:'SIN-P300',warState:'0',sure:'1',note:'1',address:'河南省郑州市东街63号联通大厦2楼',position:'联通大厦2楼',createDate:'2018.03.27'},
{deviceCode:'863703035183552',warType:'1',netCode:'-86100102',deviceNo:'MIK-P300',warState:'1',sure:'1',note:'1',address:'',position:'',createDate:'2019.04.19'},
{deviceCode:'869405030110457',warType:'1',netCode:'-86100102',deviceNo:'SUP_STXT',warState:'0',sure:'0',note:'0',address:'',position:'',createDate:'2019.04.19'},
{deviceCode:'869505041000678',warType:'2',netCode:'-86100102',deviceNo:'DZ02QS',warState:'1',sure:'0',note:'1',address:'河南省开封市',position:'',createDate:'2019.07.30'},
{deviceCode:'863703033962288',warType:'2',netCode:'-100003',deviceNo:'SUP_STXT',warState:'0',sure:'0',note:'1',address:'河南省开封市泰源街263号',position:'中国电信梅河口分公司',createDate:'2018.03.26'},
{deviceCode:'863703033974026',warType:'4',netCode:'-100003',deviceNo:'MIK-P300',warState:'1',sure:'1',note:'1',address:'河南省洛阳市东亚测试22楼',position:'',createDate:'2018.05.16'},
{deviceCode:'863703033961025',warType:'6',netCode:'-100003',deviceNo:'DZ02QS',warState:'0',sure:'0',note:'1',address:'河南省洛阳市越秀区一德路旧部前63号301',position:'',createDate:'2018.04.23',mark:'不用打电话给客户'},
{deviceCode:'863703031870574',warType:'7',netCode:'-100003',deviceNo:'SUP_STXT',warState:'1',sure:'1',note:'0',address:'河南省安阳市南平建瓯市中山路456号电信公司',position:'大厅',createDate:'2018.02.09'},
{deviceCode:'863703031878551',warType:'5',netCode:'-100003',deviceNo:'DZ02Q',warState:'0',sure:'0',note:'1',address:'河南省安阳市南平建瓯市中山路457号电信公司',position:'大厅',createDate:'2018.02.09'},
{deviceCode:'863703031818581',warType:'5',netCode:'-100003',deviceNo:'DZ02Q',warState:'0',sure:'0',note:'1',address:'河南省安阳市南平建瓯市中山路457号电信公司',position:'大厅',createDate:'2018.02.09'},
{deviceCode:'863703031810216',warType:'6',netCode:'-100003',deviceNo:'MIK-P300',warState:'0',sure:'0',note:'0',address:'河南省安阳市南平邵武熙春路电信公司',position:'大厅',createDate:'2018.02.09'},
{deviceCode:'863703031861821',warType:'6',netCode:'-100003',deviceNo:'DZ04Q',warState:'1',sure:'0',note:'1',address:'河南省安阳市南平邵武熙春路电信公司',position:'大厅',createDate:'2018.02.09'},
{deviceCode:'863703031753655',warType:'7',netCode:'-100003',deviceNo:'MIK-P300',warState:'0',sure:'0',note:'0',address:'河南省安阳市龙宝花园停车场',position:'大厅',createDate:'2018.02.27'},
{deviceCode:'860101040024965',warType:'7',netCode:'-1003',deviceNo:'R0D-CLSFFH',warState:'1',sure:'1',note:'0',address:'19AllstateParkway,Markham,Ontario,Canada,L3R5A4',position:'',createDate:'2019.01.17'},
{deviceCode:'863703032692274',warType:'4',netCode:'-1002',deviceNo:'GM-ELS180',warState:'0',sure:'1',note:'1',address:'19AllstateParkway,Markham,Ontario,Canada,L3R5A4',position:'',createDate:'2018.11.30'},
{deviceCode:'863703033998753',warType:'4',netCode:'-1002',deviceNo:'GM-ELS180',warState:'1',sure:'0',note:'1',address:'19AllstateParkway,Markham,Ontario,Canada,L3R5A4',position:'',createDate:'2018.11.30'},
{deviceCode:'863703033735809',warType:'3',netCode:'-1002',deviceNo:'GM-ELS180',warState:'0',sure:'0',note:'1',address:'19AllstateParkway,Markham,Ontario,Canada,L3R5A4',position:'',createDate:'2018.11.30'},
{deviceCode:'L123456789	',warType:'3',netCode:'-100003',deviceNo:'SUP_STXT',warState:'1',sure:'1',note:'1',address:'',position:'',createDate:'2018.12.01'}]
       },

    },
    //页面load加载
     mounted() {
      this.handleSearch();
    }
}
</script>


// WEBPACK FOOTER //
// monitor.vue?72ff7d88